import {clsx} from 'clsx'

import styles from './LeadingVisual.module.css'

type LeadingVisualProps = {
  children: React.ReactNode
  className?: string
}

const LeadingVisual = ({children, className}: LeadingVisualProps) => (
  <div className={clsx(styles.container, className)}>
    <div>{children}</div>
  </div>
)
LeadingVisual.displayName = 'LeadingVisualProps'

export default LeadingVisual
